<ion-header>
  <app-header
    [isHome]="false"
    [logo]="merchant.merchantLogo"
    [sourceBanner]="merchant.merchantBanner"
    [merchantName]="'Stone Creek Coffee'"
    [merchantHeaderTitle]="merchant?.merchantHeaderTitle"
    [merchantHeaderText]="merchant?.merchantHeaderText"
    pageName="merchant"
    [showMerchantLogo]="true"
    [isCreek]="true"
  >
  </app-header>
</ion-header>

<ion-content>
  <div class="content">
    <p class="title">Order History</p>
    <div *ngIf="!isSpinner; then orders else spinner"></div>
    <ng-template #orders>
      <ion-grid *ngIf="previousOrders && previousOrders.length > 0">
        <ion-row>
          <ion-card *ngFor="let order of previousOrders" [class]="order.locationId" [ngStyle]="{ '--background': getRestaurantBrandColor(order.locationId) }">
            <ion-card-header>
              <ion-row class="margin-5">
                <ion-col size="6">
                  <ion-text>{{ order.locationName }}</ion-text>
                </ion-col>
                <ion-col size="6">
                  <ion-text class="float-right"> {{ order.datetime_created | date }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="margin-5">
                <ion-col size="12">
                  <ion-text>Order #{{ order.number }}</ion-text>
                </ion-col>
              </ion-row>
            </ion-card-header>
            <ion-card-content>
              <ion-row *ngFor="let item of order.lineItems">
                <ion-col
                  size="12"
                  *ngIf="
                  item.name.toLowerCase() !== 'kyoo service charge' &&
                  item?.name.toLowerCase() !== 'service charge' &&
                  item.name.toLowerCase() !== 'service fee'
                "
                >
                  <ion-text class="item">
                    {{ item.name }} <span>x {{ item.quantity }}</span></ion-text
                  >
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="6">
                  <ion-text
                    class="float-left margin-top-bottom border-bottom bold-text"
                    (click)="viewReceipt(order.squareReceiptUrl)"
                    *ngIf="order.squareReceiptUrl && order.squareReceiptUrl != null && order.squareReceiptUrl.trim().length > 0"
                  >View receipt</ion-text
                  >
                </ion-col>
                <ion-col size="6">
                  <ion-text class="float-right margin-top-bottom border-bottom bold-text" (click)="reOrder(order)">Order again</ion-text>
                </ion-col>
              </ion-row>
            </ion-card-content>
          </ion-card>
        </ion-row>
        <div class="load-more">
          <button mat-button class="more-button" (click)="getPreviousOrders()" *ngIf="!hideLoadMore">Load more</button>
        </div>
      </ion-grid>
      <ion-grid>
        <ion-row>
          <app-verify-phone-number
            [title]="title"
            (getPreviousOrders)="getPreviousOrders()"
            *ngIf="!userVerified && previousOrders.length === 0"
          ></app-verify-phone-number>
        </ion-row>
      </ion-grid>
      <ion-grid *ngIf="userVerified && previousOrders.length === 0">
        <ion-row>
          <ion-card>
            <p class="bold-text margin-top-bottom">No orders found</p>
          </ion-card>
        </ion-row>
      </ion-grid>
    </ng-template>

  </div>
</ion-content>

<ng-template #spinner>
  <div class="spinner-wrapper" *ngIf="!checkPlatform">
    <app-spinner></app-spinner>
  </div>
</ng-template>
